import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {reduxForm, getFormValues, Field} from 'redux-form';
// import {HttpStatusCode} from 'axios';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import withStyles from '@mui/styles/withStyles';

import withRouter from '../../../organisms/withRouter.js';
import withFormatMessage from '../../../organisms/withFormatMessage.js';
import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import PaperPart from '../../../atoms/PaperPart.js';
// import {postRequest} from '../../../../common/backend.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import PageTitle from '../../../molecules/PageTitle.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
// import {requiredCheck, lengthCheck} from '../../../../common/inputCheck.js';
import SaveIcon from '@mui/icons-material/Save';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import {renderTextField,
  renderCheckbox,
  renderRadioGroup,
} from '../../../atoms/CustomPart.js';
import * as validateRule from '../../../validateRule.js';
import {Typography,
  // FormControl, FormGroup,
  // FormLabel,
  FormControlLabel,
  Radio,
} from '@mui/material';
import {createUpload} from '../../../../common/commonGmn.js';

import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {formatDate} from '../../../../common/common.js';
import {sysErr} from '../../../../common/commonGmn.js';

const styles = (theme) => ({
});

const uploadFiles = {
  picture: {componentId: 'picture', maxFileCount: 4, maxFileSize: 10485760, required: false,
    previewFlag: true, previewWidth: '35%', acceptFileType: '.png,.jpg,.jpeg',
    fileSetHandler: null, downloadHandler: null, initFile: [], disabled: false,
  },
};

/**
 * 点検入力情報ダイアログ
 *
 * 遷移元指定パラメータ
 *
 */
class TkInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      warningMessages: null,
      // hksntkHuryoNaiyoMap: [],
      hksntkTktniMap: [],
      // hksntkTnknkMap: [],
      showDntFuryoTenpu: [],
      showHksFuryoTenpu: [],
      showKkFuryoTenpu: [],
      tkInfo: {},
    };

    this.pictureFiles = [];
    this.pictureFilesMap = [];
    this.pictureDelFiles = [];
    // 添付ファイル設定
    this.initUploadFileProps();
  }

  /**
   * アップロードファイル設定初期化
   */
  initUploadFileProps = () => {
    uploadFiles['picture'].initFile = [];
    uploadFiles['picture'].fileSetHandler = this.setUploadFiles;
    // uploadFiles['picture'].downloadHandler = this.doDownload.bind(this);
    this.pictureFiles = [];
    this.pictureFilesMap = [];
    this.pictureDelFiles = [];
  };

  /**
   * アップロードファイル設定
   * @param {object} files
   * @param {object} deleteFiles
   */
  setUploadFiles = (files, deleteFiles) => {
    try {
      let _files = [];
      let _filesMap = [];
      for (let file of files) {
        _files.push(file);
      }
      _filesMap.push({name: 'picture', selectFiles: files});

      this.pictureFiles = _files;
      this.pictureFilesMap = _filesMap;
      if (deleteFiles && deleteFiles.length > 0) {
        this.pictureDelFiles.push(deleteFiles[0]);
      }
      this.setState({
        isModified: true,
      });
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * アップロードファイル設定
   * 初期処理で保存済のファイルと部品の活性・非活性を設定する
   * @param {boolean} isDisabled
   */
  setUploadFileProps = (isDisabled) => {
    uploadFiles['picture'].initFile = this.pictureFiles;
    uploadFiles['picture'].disabled = isDisabled;
    this.pictureDelFiles = [];
    this.pictureFilesMap = [];
    // this.setState({isMobile: true});
  };

  /**
   * 初期処理
   */
  async componentDidMount() {
    this.props.reset();
    this.getKbnMapData();
    this.getInitializeData();
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    // 仮データ
    let _tkInfo = {...this.state.tkInfo};
    let _isDisabled = false;
    let _showDntFuryoTenpu = this.state.showDntFuryoTenpu;
    let _showHksFuryoTenpu = this.state.showHksFuryoTenpu;
    let _showKkFuryoTenpu = this.state.showKkFuryoTenpu;

    let sysDate = formatDate(new Date(), 'yyyy-MM-dd');
    if (this.props.tkStatus === '未着手') {
      _tkInfo = {
        tkDate: sysDate,
      };
      // _showDntFuryoTenpu = [
      //   {targetId: 'dntNoDiffer', cd: '', cdName: '電柱番号相違'},
      // ];
    } else if (this.props.tkStatus === '承認中') {
      _tkInfo = {
        tkDate: '2025-01-02',
        dntNoDiffer: false,
        hikikomisenTkResult: '2',
        checkbox013: true,
        checkbox032: true,
        checkbox032Fuyou: true,
        keikiTkResult: '2',
        checkbox111: true,
        tkMemo: 'テストメモ15',
        isFuryoHikikomisenShow: true,
        isFuryoKeikiShow: true,
        // tkStatus: '承認中',
        // tsStatus: '承認中',
      };
      _isDisabled = true;
      _showHksFuryoTenpu = [
        {targetId: 'checkbox013', cd: '01', cdName: '電線（離隔）'},
        {targetId: 'checkbox032', cd: '03', cdName: '家屋側支持点'},
      ];
      _showKkFuryoTenpu = [
        {targetId: 'checkbox111', cd: '11', cdName: '計量器（変流器含む）'},
      ];
    } else {
      _tkInfo = {
        tkDate: '2025-01-01',
        dntNoDiffer: true,
        hikikomisenTkResult: '4',
        checkbox921: true,
        keikiTkResult: '3',
        checkbox931: true,
        checkbox932: true,
        tkMemo: 'テストメモ16',
        isFunouHikikomisenShow: true,
        isFuyouKeikiShow: true,
      };
      _showDntFuryoTenpu = [
        {targetId: 'dntNoDiffer', cd: '', cdName: '電柱番号相違'},
      ];
    }

    this.props.doSetInitValues(_tkInfo);

    // this.pictureFiles = response.files;
    this.setUploadFileProps(_isDisabled);

    this.setState({
      isFuryoHikikomisenShow: _tkInfo.isFuryoHikikomisenShow,
      isFunouHikikomisenShow: _tkInfo.isFunouHikikomisenShow,
      isFuryoKeikiShow: _tkInfo.isFuryoKeikiShow,
      isFuyouKeikiShow: _tkInfo.isFuyouKeikiShow,
      showDntFuryoTenpu: _showDntFuryoTenpu,
      showHksFuryoTenpu: _showHksFuryoTenpu,
      showKkFuryoTenpu: _showKkFuryoTenpu,
      tkInfo: _tkInfo,
      isDisabled: _isDisabled,
    });
  };

  /**
   * 区分データ
   */
  getKbnMapData = async () => {
    // // 引込線点検不良内容コード
    // let _hksntkHuryoNaiyoMap = [
    //   {cd: '001', cdName: '良', valueString1: '0', valueString2: '00', valueString3: '1'},
    //   {cd: '011', cdName: '地上高不足', valueString1: '0', valueString2: '01', valueString3: '2'},
    //   {cd: '012', cdName: '離隔不足（建物）', valueString1: '0', valueString2: '01', valueString3: '2'},
    //   {cd: '013', cdName: '離隔不足（弱電）', valueString1: '0', valueString2: '01', valueString3: '2'},
    //   {cd: '014', cdName: '樹木接触', valueString1: '0', valueString2: '01', valueString3: '2'},
    //   {cd: '021', cdName: '断線', valueString1: '0', valueString2: '02', valueString3: '2'},
    //   {cd: '022', cdName: '損傷・劣化', valueString1: '0', valueString2: '02', valueString3: '2'},
    //   {cd: '031', cdName: '脱落', valueString1: '0', valueString2: '03', valueString3: '2'},
    //   {cd: '032', cdName: '腐食', valueString1: '0', valueString2: '03', valueString3: '2'},
    //   {cd: '033', cdName: 'がいし破損', valueString1: '0', valueString2: '03', valueString3: '2'},
    //   {cd: '041', cdName: '脱落', valueString1: '0', valueString2: '04', valueString3: '2'},
    //   {cd: '911', cdName: '全使撤済', valueString1: '0', valueString2: '91', valueString3: '3'},
    //   {cd: '912', cdName: '地中引込', valueString1: '0', valueString2: '91', valueString3: '3'},
    //   {cd: '913', cdName: '高圧引込', valueString1: '0', valueString2: '91', valueString3: '3'},
    //   {cd: '921', cdName: '特定不能', valueString1: '0', valueString2: '92', valueString3: '4'},
    //   {cd: '922', cdName: '昇柱要', valueString1: '0', valueString2: '92', valueString3: '4'},
    //   {cd: '923', cdName: '立入不可', valueString1: '0', valueString2: '92', valueString3: '4'},
    //   {cd: '101', cdName: '良', valueString1: '1', valueString2: '10', valueString3: '1'},
    //   {cd: '111', cdName: '傾斜・脱落', valueString1: '1', valueString2: '11', valueString3: '2'},
    //   {cd: '112', cdName: '損傷', valueString1: '1', valueString2: '11', valueString3: '2'},
    //   {cd: '121', cdName: '傾斜・脱落', valueString1: '1', valueString2: '12', valueString3: '2'},
    //   {cd: '122', cdName: '損傷', valueString1: '1', valueString2: '12', valueString3: '2'},
    //   {cd: '131', cdName: '傾斜・脱落', valueString1: '1', valueString2: '13', valueString3: '2'},
    //   {cd: '132', cdName: '損傷', valueString1: '1', valueString2: '13', valueString3: '2'},
    //   {cd: '931', cdName: '全使撤済', valueString1: '1', valueString2: '93', valueString3: '3'},
    //   {cd: '932', cdName: '計器なし', valueString1: '1', valueString2: '93', valueString3: '3'},
    //   {cd: '941', cdName: '特定不能', valueString1: '1', valueString2: '94', valueString3: '4'},
    //   {cd: '942', cdName: '立入不可', valueString1: '1', valueString2: '94', valueString3: '4'},

    // ];

    // 引込線点検・点検単位コード
    let _hksntkTktniMap = [
      // {cd: '00', cdName: '良', valueString1: '0'},
      {cd: '01', cdName: '電線（離隔）', valueString1: '0'},
      {cd: '02', cdName: '電線（本体）', valueString1: '0'},
      {cd: '03', cdName: '家屋側支持点', valueString1: '0'},
      {cd: '04', cdName: '防護管', valueString1: '0'},
      // {cd: '91', cdName: '不要', valueString1: '0'},
      // {cd: '92', cdName: '不能', valueString1: '0'},
      // {cd: '10', cdName: '良', valueString1: '1'},
      {cd: '11', cdName: '計量器（変流器含む）', valueString1: '1'},
      {cd: '12', cdName: '計器箱', valueString1: '1'},
      {cd: '13', cdName: 'タイムスイッチ等', valueString1: '1'},
      // {cd: '93', cdName: '不要', valueString1: '1'},
      // {cd: '94', cdName: '不能', valueString1: '1'},
    ];

    // // 引込線点検・点検結果コード
    // let _hksntkTnknkMap = [
    //   {cd: '1', cdName: '良'},
    //   {cd: '2', cdName: '不良'},
    //   {cd: '3', cdName: '不要'},
    //   {cd: '4', cdName: '不能'},
    // ];

    this.setState({
      // hksntkHuryoNaiyoMap: _hksntkHuryoNaiyoMap,
      hksntkTktniMap: _hksntkTktniMap,
      // hksntkTnknkMap: _hksntkTnknkMap,
    });
  };

  /**
   * 確定
   */
  doSave = () => {
    const {values} = this.props;
    // 引込線点検・点検結果コード
    let _tkTnknkMap = {
      '1': '良',
      '2': '不良',
      '3': '不要',
      '4': '不能',
    };
    let data = {
      supplyPointNo: this.props.supplyPointNo,
      tkHikomiSen: _tkTnknkMap[values.hikikomisenTkResult],
      tkKeki: _tkTnknkMap[values.keikiTkResult],
      tkDtNo: values.dntNoDiffer ? '有': '',
      tkMemo: values.tkMemo,
      btnFlag: '1', // 1: 確定ボタン
    };
    this.props.closeButton(data);
  };

  /**
   * 戻る
   */
  doBack = () => {
    this.props.reset();
    let data = {
      btnFlag: '2',
    };
    this.props.closeButton(data);
  };

  // /**
  //  * 必須チェック
  //  * @param {*} required
  //  * @param {*} header
  //  * @param {*} value
  //  * @param {*} rowIndex
  //  * @return {*} 結果
  //  */
  // _requiredCheck = (required, header, value, rowIndex=' ') => {
  //   if (required) {
  //     return requiredCheck(header, value, rowIndex);
  //   }
  //   return {};
  // };

  // /**
  //  * 桁数チェック
  //  * @param {*} maxLength
  //  * @param {*} header
  //  * @param {*} value
  //  * @param {*} rowIndex
  //  * @return {*} 結果
  //  */
  // _lengthCheck = (maxLength, header, value, rowIndex) => {
  //   if (maxLength && maxLength > 0) {
  //     return lengthCheck(header, value, maxLength, rowIndex);
  //   }
  //   return {};
  // };


  /**
   * 電柱番号相違チェックボックスのイベント
   * @param {*} event
   */
  _handleDntNoDifferChange = (event) => {
    let _showDntFuryoTenpu = [...this.state.showDntFuryoTenpu];

    let item = {
      targetId: event.target.id,
      cd: '',
      cdName: '電柱番号相違',
    };

    if (event.target.checked) {
      _showDntFuryoTenpu.push(item);
    } else {
      _showDntFuryoTenpu = [];
    }
    this.setState({
      showDntFuryoTenpu: _showDntFuryoTenpu,
    });
  };

  /**
   * 引込線ラジオボタンのイベント
   * @param {*} event
   */
  _handleHksChangeRadio = (event) => {
    const radioVal = event.target.value;
    let _isFuryoHikikomisenShow = false;
    let _isFuyouHikikomisenShow = false;
    let _isFunouHikikomisenShow = false;
    if (radioVal === '2') {
      _isFuryoHikikomisenShow = true;
    } else if (radioVal === '3') {
      _isFuyouHikikomisenShow = true;
    } else if (radioVal === '4') {
      _isFunouHikikomisenShow = true;
    }
    this.setState({
      isFuryoHikikomisenShow: _isFuryoHikikomisenShow,
      isFuyouHikikomisenShow: _isFuyouHikikomisenShow,
      isFunouHikikomisenShow: _isFunouHikikomisenShow,
    });

    let _showHksFuryoTenpu = this.state.showHksFuryoTenpu;
    if (_showHksFuryoTenpu != null && _showHksFuryoTenpu.length > 0) {
      _showHksFuryoTenpu.forEach((obj) => {
        this.props.change(obj.targetId, false);
      });
      this.setState({
        showHksFuryoTenpu: [],
      });
    }
  };

  /**
   * 計器ラジオボタンのイベント
   * @param {*} event
   */
  _handleKkChangeRadio = (event) => {
    const radioVal = event.target.value;
    let _isFuryoKeikiShow = false;
    let _isFuyouKeikiShow = false;
    let _isFunouKeikiShow = false;
    if (radioVal === '2') {
      _isFuryoKeikiShow = true;
    } else if (radioVal === '3') {
      _isFuyouKeikiShow = true;
    } else if (radioVal === '4') {
      _isFunouKeikiShow = true;
    }
    this.setState({
      isFuryoKeikiShow: _isFuryoKeikiShow,
      isFuyouKeikiShow: _isFuyouKeikiShow,
      isFunouKeikiShow: _isFunouKeikiShow,
    });

    let _showKkFuryoTenpu = this.state.showKkFuryoTenpu;
    if (_showKkFuryoTenpu != null && _showKkFuryoTenpu.length > 0) {
      _showKkFuryoTenpu.forEach((obj) => {
        this.props.change(obj.targetId, false);
      });
      this.setState({
        showKkFuryoTenpu: [],
      });
    }
  };

  /**
   * 引込線不良の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderHikikomisenFuryo = () =>{
    const isFuyouShow = this.props.tkStatus === '承認中';
    const isDisabled = this.state.isDisabled;
    return (
      <React.Fragment>
        <Typography variant="subtitle1" gutterBottom style={{backgroundColor: '#4F89C6'}}>【不良】</Typography>
        {/** 不良情報 */}
        <Grid key="hikikomisenFuryoInfo" item xs={12}>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={2}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>電線（離隔）</Typography>
            </Grid>
            <Grid item sm={10}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
                item
              >
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox011'
                        name='checkbox011'
                        component={renderCheckbox}
                        label='地上高不足'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeHksCheckbox(e, v, '01');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox011Fuyou"
                          name="checkbox011Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox012'
                        name='checkbox012'
                        component={renderCheckbox}
                        label='離隔不足（建物）'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeHksCheckbox(e, v, '01');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox012Fuyou"
                          name="checkbox012Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>

              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={2}>
            </Grid>
            <Grid item sm={10}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox013'
                        name='checkbox013'
                        component={renderCheckbox}
                        label='離隔不足（弱電）'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeHksCheckbox(e, v, '01');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox013Fuyou"
                          name="checkbox013Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox014'
                        name='checkbox014'
                        component={renderCheckbox}
                        label='樹木接触'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeHksCheckbox(e, v, '01');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox014Fuyou"
                          name="checkbox014Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={2}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>電線（本体）</Typography>
            </Grid>
            <Grid item sm={10}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox021'
                        name='checkbox021'
                        component={renderCheckbox}
                        label='断線'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeHksCheckbox(e, v, '02');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox021Fuyou"
                          name="checkbox021Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox022'
                        name='checkbox022'
                        component={renderCheckbox}
                        label='損傷・劣化'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeHksCheckbox(e, v, '02');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox022Fuyou"
                          name="checkbox022Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={2}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>家屋側支持点</Typography>
            </Grid>
            <Grid item sm={10}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox031'
                        name='checkbox031'
                        component={renderCheckbox}
                        label='脱落'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeHksCheckbox(e, v, '03');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox031Fuyou"
                          name="checkbox031Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox032'
                        name='checkbox032'
                        component={renderCheckbox}
                        label='腐食'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeHksCheckbox(e, v, '03');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox032Fuyou"
                          name="checkbox032Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={2}>
            </Grid>
            <Grid item sm={10}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox033'
                        name='checkbox033'
                        component={renderCheckbox}
                        label='がいし破損'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeHksCheckbox(e, v, '03');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox033Fuyou"
                          name="checkbox033Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={2}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>防  護  管</Typography>
            </Grid>
            <Grid item sm={10}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox041'
                        name='checkbox041'
                        component={renderCheckbox}
                        label='脱落'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeHksCheckbox(e, v, '04');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox041Fuyou"
                          name="checkbox041Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/** 不良写真 */}
        <Grid key="hikikomisenFuryoTenpu" item xs={12}>
          {this.getFuryoTenfu(this.state.showHksFuryoTenpu)}
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * 引込線不要の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderHikikomisenFuyou = () =>{
    const isDisabled = this.state.isDisabled;
    return (
      <React.Fragment>
        <Typography variant="subtitle1" gutterBottom style={{backgroundColor: '#4F89C6'}}>【不要】</Typography>
        {/** 不要情報 */}
        <Grid key="hikikomisenFuyouInfo" item xs={12}>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={2}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>不要</Typography>
            </Grid>
            <Grid item sm={10}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={4}>
                  <Field className='checkbox'
                    id='checkbox911'
                    name='checkbox911'
                    component={renderCheckbox}
                    label='全使撤済'
                    validate={[]}
                    onChange={(e, v) => {
                    }}
                    disabled={isDisabled}
                  />
                </Grid>
                <Grid item sm={4}>
                  <Field className='checkbox'
                    id='checkbox912'
                    name='checkbox912'
                    component={renderCheckbox}
                    label='地中引込'
                    validate={[]}
                    onChange={(e, v) => {
                    }}
                    disabled={isDisabled}
                  />
                </Grid>
                <Grid item sm={4}>
                  <Field className='checkbox'
                    id='checkbox913'
                    name='checkbox913'
                    component={renderCheckbox}
                    label='高圧引込'
                    validate={[]}
                    onChange={(e, v) => {
                    }}
                    disabled={isDisabled}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * 引込線不能の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderHikikomisenFunou = () =>{
    const isDisabled = this.state.isDisabled;
    return (
      <React.Fragment>
        <Typography variant="subtitle1" gutterBottom style={{backgroundColor: '#4F89C6'}}>【不能】</Typography>
        {/** 不能情報 */}
        <Grid key="hikikomisenFunouInfo" item xs={12}>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={2}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>不能</Typography>
            </Grid>
            <Grid item sm={10}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={4}>
                  <Field className='checkbox'
                    id='checkbox921'
                    name='checkbox921'
                    component={renderCheckbox}
                    label='特定不能'
                    validate={[]}
                    onChange={(e, v) => {
                    }}
                    disabled={isDisabled}
                  />
                </Grid>
                <Grid item sm={4}>
                  <Field className='checkbox'
                    id='checkbox922'
                    name='checkbox922'
                    component={renderCheckbox}
                    label='昇柱要'
                    validate={[]}
                    onChange={(e, v) => {
                    }}
                    disabled={isDisabled}
                  />
                </Grid>
                <Grid item sm={4}>
                  <Field className='checkbox'
                    id='checkbox923'
                    name='checkbox923'
                    component={renderCheckbox}
                    label='立入不可'
                    validate={[]}
                    onChange={(e, v) => {
                    }}
                    disabled={isDisabled}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * 計器不良の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderKeikiFuryo = () =>{
    const isFuyouShow = this.props.tkStatus === '承認中';
    const isDisabled = this.state.isDisabled;
    return (
      <React.Fragment>
        <Typography variant="subtitle1" gutterBottom style={{backgroundColor: '#4F89C6'}}>【不良】</Typography>
        {/** 不良情報 */}
        <Grid key="keikiFuryoInfo" item xs={12}>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={3}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>計量器（変流器含む）</Typography>
            </Grid>
            <Grid item sm={9}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox111'
                        name='checkbox111'
                        component={renderCheckbox}
                        label='傾斜・脱落'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeKkCheckbox(e, v, '11');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox111Fuyou"
                          name="checkbox111Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox112'
                        name='checkbox112'
                        component={renderCheckbox}
                        label='損傷'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeKkCheckbox(e, v, '11');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox112Fuyou"
                          name="checkbox112Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={3}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>計器箱</Typography>
            </Grid>
            <Grid item sm={9}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox121'
                        name='checkbox121'
                        component={renderCheckbox}
                        label='傾斜・脱落'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeKkCheckbox(e, v, '12');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox121Fuyou"
                          name="checkbox121Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox122'
                        name='checkbox122'
                        component={renderCheckbox}
                        label='損傷'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeKkCheckbox(e, v, '12');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox122Fuyou"
                          name="checkbox122Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={3}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>タイムスイッチ等</Typography>
            </Grid>
            <Grid item sm={9}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox131'
                        name='checkbox131'
                        component={renderCheckbox}
                        label='傾斜・脱落'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeKkCheckbox(e, v, '13');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox131Fuyou"
                          name="checkbox131Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={6}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}>
                    <Grid item>
                      <Field className='checkbox'
                        id='checkbox132'
                        name='checkbox132'
                        component={renderCheckbox}
                        label='損傷'
                        validate={[]}
                        onChange={(e, v) => {
                          this._handleChangeKkCheckbox(e, v, '13');
                        }}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item>
                      {isFuyouShow &&
                      <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        style={{marginTop: '1px'}}>
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{'('}</Typography>
                        <Field className='checkbox'
                          id="checkbox132Fuyou"
                          name="checkbox132Fuyou"
                          component={renderCheckbox}
                          label="不要"
                          validate={[]}
                          sx={{marginLeft: '5px'}}
                          disabled={!isDisabled}
                        />
                        <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px -5px'}}>{')'}</Typography>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/** 不良写真 */}
        <Grid key="keikiFuryoTenpu" item xs={12}>
          {this.getFuryoTenfu(this.state.showKkFuryoTenpu)}
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * 計器不要の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderKeikiFuyou = () =>{
    const isDisabled = this.state.isDisabled;
    return (
      <React.Fragment>
        <Typography variant="subtitle1" gutterBottom style={{backgroundColor: '#4F89C6'}}>【不要】</Typography>
        {/** 不要情報 */}
        <Grid key="keikiFuyouInfo" item xs={12}>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={2}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>不要</Typography>
            </Grid>
            <Grid item sm={10}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={4}>
                  <Field className='checkbox'
                    id='checkbox931'
                    name='checkbox931'
                    component={renderCheckbox}
                    label='全使撤済'
                    validate={[]}
                    onChange={(e, v) => {
                    }}
                    disabled={isDisabled}
                  />
                </Grid>
                <Grid item sm={4}>
                  <Field className='checkbox'
                    id='checkbox932'
                    name='checkbox932'
                    component={renderCheckbox}
                    label='計器なし'
                    validate={[]}
                    onChange={(e, v) => {
                    }}
                    disabled={isDisabled}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * 計器不能の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderKeikiFunou = () =>{
    const isDisabled = this.state.isDisabled;
    return (
      <React.Fragment>
        <Typography variant="subtitle1" gutterBottom style={{backgroundColor: '#4F89C6'}}>【不能】</Typography>
        {/** 不能情報 */}
        <Grid key="keikiFunouInfo" item xs={12}>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={2}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>不能</Typography>
            </Grid>
            <Grid item sm={10}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid item sm={4}>
                  <Field className='checkbox'
                    id='checkbox941'
                    name='checkbox941'
                    component={renderCheckbox}
                    label='特定不能'
                    validate={[]}
                    onChange={(e, v) => {
                    }}
                    disabled={isDisabled}
                  />
                </Grid>
                <Grid item sm={4}>
                  <Field className='checkbox'
                    id='checkbox942'
                    name='checkbox942'
                    component={renderCheckbox}
                    label='立入不可'
                    validate={[]}
                    onChange={(e, v) => {
                    }}
                    disabled={isDisabled}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * 写真添付の要素生成
   * @param {*} items 引込線点検不良内容コード
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  getFuryoTenfu = (items) => {
    let retItems = [];
    let isShow = false;
    // uploadFiles.picture.disabled = this.state.isDisabled;

    if (items != null && items.length > 0) {
      let tenpuItems = items.map((obj) => {
        const newObj = {...obj};
        delete newObj['targetId'];
        return newObj;
      }).filter((obj, index, self) =>
        index === self.findIndex((t) => t.cd === obj.cd));

      isShow = true;
      tenpuItems.forEach((item) => {
        let itemCd = item.cd;
        let itemCdName = item.cdName;
        retItems.push(
            <Grid key={'keyFuryoNaiyo'+itemCd} item sm={12}>
              <Grid key={'keyFuryoNaiyoCode'+itemCd} item xs={6} sx={{marginTop: '10px'}}>
                {itemCd !== '' &&
                <Field
                  id={'tkFuryoNaiyoCode'+itemCd}
                  name={'tkFuryoNaiyoCode'+itemCd}
                  component={renderTextField}
                  className='fields'
                  fullWidth
                  label="不良内容"
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: true,
                    value: itemCdName,
                  }}
                />
                }
              </Grid>

              <Grid
                container
                justifyContent="center"
                alignItems="flex-start"
                spacing={1}
              >
                {createUpload(uploadFiles.picture)}
              </Grid>
            </Grid>,
        );
      });
    }
    return ( isShow &&
      <Grid
        container
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={0}
        style={{'border': '1px solid lightblue'}}
      >
        <Grid item sm={2}>
          <Typography variant="subtitle1" gutterBottom style={{margin: '10px 0px 0px 10px'}}>写真添付</Typography>
        </Grid>
        <Grid key="keyFuryoNaiyo" item sm={9} style={{marginBottom: '10px'}}>
          {retItems}
        </Grid>
      </Grid>
    );
  };

  /**
   * 引込線チェックボックスのイベント
   * @param {*} event イベント
   * @param {*} val 値
   * @param {*} cd 点検単位コード
   */
  _handleChangeHksCheckbox = (event, val, cd) => {
    let _showHksFuryoTenpu = [...this.state.showHksFuryoTenpu];

    let _cdName = this.state.hksntkTktniMap
        .filter((obj) => obj.cd === cd)
        .map((obj) => obj.cdName);

    let item = {
      targetId: event.target.id,
      cd: cd,
      cdName: _cdName,
    };

    if (val) {
      _showHksFuryoTenpu.push(item);
    } else {
      _showHksFuryoTenpu = _showHksFuryoTenpu.reduce((acc, curr) => {
        if (curr.targetId !== event.target.id) {
          acc.push(curr);
        }
        return acc;
      }, []);
    }

    this.setState({
      showHksFuryoTenpu: _showHksFuryoTenpu,
    });
  };

  /**
   * 計器チェックボックスのイベント
   * @param {*} event イベント
   * @param {*} val 値
   * @param {*} cd 点検単位コード
   */
  _handleChangeKkCheckbox = (event, val, cd) => {
    let _showKkFuryoTenpu = [...this.state.showKkFuryoTenpu];
    let _cdName = this.state.hksntkTktniMap
        .filter((obj) => obj.cd === cd)
        .map((obj) => obj.cdName);

    let item = {
      targetId: event.target.id,
      cd: cd,
      cdName: _cdName,
    };

    if (val) {
      _showKkFuryoTenpu.push(item);
    } else {
      _showKkFuryoTenpu = _showKkFuryoTenpu.reduce((acc, curr) => {
        if (curr.targetId !== event.target.id) {
          acc.push(curr);
        }
        return acc;
      }, []);
    }
    this.setState({
      showKkFuryoTenpu: _showKkFuryoTenpu,
    });
  };


  render() {
    const {
      // classes,
      handleSubmit,
    } = this.props;
    const isDisabled = this.state.isDisabled;
    const isFuyouShow = this.props.tkStatus === '承認中';
    return (
      <Modal
        open={this.props.modalOpen}
        style={{
          maxWidth: 1000,
          marginLeft: 'auto',
          marginRight: 'auto',
          overflow: 'visible',
        }}
        disableEnforceFocus={true}
      >
        <form noValidate autoComplete="off" style={{maxHeight: '100vh'}} >
          <PaperPart style={{maxHeight: '90vh', overflow: 'auto scroll'}}>
            <PageTitle pageTitle={'点検結果詳細'}/>
            <div style={{marginBottom: '20px'}} />
            <Grid container
              justifyContent="center"
              alignItems="flex-start"
              spacing={1}>
              <Grid key="keyTkInfoMsg" item xs={12}>
                <WarningMessageArea messages={this.state.warningMessages}/>
              </Grid>
              <Grid key="keyTkInfoArea" item xs={12}>
                <Grid key="keyTkDate" item xs={2}>
                  <Field
                    id="tkDate"
                    name="tkDate"
                    component={renderTextField}
                    className='fields'
                    fullWidth
                    label="点検日"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    validate={[
                      validateRule.date,
                    ]}
                    InputProps={{
                      readOnly: true,
                    }}
                    // disabled={isDisabled}
                  />
                </Grid>
                <Grid key="keyDntNoDiffer" item xs={12}>
                  <PaperPart>
                    <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>電柱番号相違</Typography>
                    <Grid
                      container
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px 10px'}}>電柱番号相違</Typography>
                      <Field className='checkbox'
                        id="dntNoDiffer"
                        name="dntNoDiffer"
                        component={renderCheckbox}
                        label="有"
                        onChange={this._handleDntNoDifferChange}
                        validate={[]}
                        sx={{marginLeft: '20px'}}
                        disabled={isDisabled}
                      />
                    </Grid>
                    {/** 電柱番号相違写真 */}
                    <Grid key="dntNoDifferTenpu" item xs={12}>
                      {this.getFuryoTenfu(this.state.showDntFuryoTenpu)}
                    </Grid>
                  </PaperPart>
                </Grid>
                <Grid key="keyHikikomisen" item xs={12}>
                  <PaperPart>
                    <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>引込線</Typography>
                    <Grid
                      container
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px 10px'}}>点検結果</Typography>
                      <Field
                        key='hikikomisenTkResult'
                        id='hikikomisenTkResult'
                        name='hikikomisenTkResult'
                        // label=""
                        // defaultValue={'1'}
                        component={renderRadioGroup}
                        onChange={this._handleHksChangeRadio}
                        row
                      >
                        <FormControlLabel
                          key='tkResultHks1'
                          value='1'
                          control={<Radio />}
                          label={'良'}
                          disabled={isDisabled}
                        />
                        <FormControlLabel
                          key='tkResultHks2'
                          value='2'
                          control={<Radio />}
                          label={'不良'}
                          disabled={isDisabled}
                        />
                        <FormControlLabel
                          key='tkResultHks3'
                          value='3'
                          control={<Radio />}
                          label={'不要'}
                          disabled={isDisabled}
                        />
                        <FormControlLabel
                          key='tkResultHks4'
                          value='4'
                          control={<Radio />}
                          label={'不能'}
                          disabled={isDisabled}
                        />
                      </Field>
                    </Grid>
                    {this.state.isFuryoHikikomisenShow &&
                    <Grid item xs={12} style={{'border': '1px solid lightblue'}}>
                      {this._renderHikikomisenFuryo()}
                    </Grid>
                    }
                    {this.state.isFuyouHikikomisenShow &&
                      <Grid item xs={12} style={{'border': '1px solid lightblue'}}>
                        {this._renderHikikomisenFuyou()}
                      </Grid>
                    }
                    {this.state.isFunouHikikomisenShow &&
                    <Grid item xs={12} style={{'border': '1px solid lightblue'}}>
                      {this._renderHikikomisenFunou()}
                    </Grid>
                    }
                  </PaperPart>
                </Grid>
                <Grid key="keyKeiki" item xs={12}>
                  <PaperPart>
                    <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>計器</Typography>
                    <Grid
                      container
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px 10px'}}>点検結果</Typography>

                      <Field
                        key='keikiTkResult'
                        id='keikiTkResult'
                        name='keikiTkResult'
                        // label=""
                        // defaultValue={'1'}
                        component={renderRadioGroup}
                        onChange={this._handleKkChangeRadio}
                        row
                      >
                        <FormControlLabel
                          key='tkResultKk1'
                          value='1'
                          control={<Radio />}
                          label={'良'}
                          disabled={isDisabled}
                        />
                        <FormControlLabel
                          key='tkResultKk2'
                          value='2'
                          control={<Radio />}
                          label={'不良'}
                          disabled={isDisabled}
                        />
                        <FormControlLabel
                          key='tkResultKk3'
                          value='3'
                          control={<Radio />}
                          label={'不要'}
                          disabled={isDisabled}
                        />
                        <FormControlLabel
                          key='tkResultKk4'
                          value='4'
                          control={<Radio />}
                          label={'不能'}
                          disabled={isDisabled}
                        />
                      </Field>
                    </Grid>
                    {this.state.isFuryoKeikiShow &&
                    <Grid item xs={12} style={{'border': '1px solid lightblue'}}>
                      {this._renderKeikiFuryo()}
                    </Grid>
                    }
                    {this.state.isFuyouKeikiShow &&
                      <Grid item xs={12} style={{'border': '1px solid lightblue'}}>
                        {this._renderKeikiFuyou()}
                      </Grid>
                    }
                    {this.state.isFunouKeikiShow &&
                    <Grid item xs={12} style={{'border': '1px solid lightblue'}}>
                      {this._renderKeikiFunou()}
                    </Grid>
                    }
                  </PaperPart>
                </Grid>
                <Grid key="keyTkMemo" item xs={12}>
                  <PaperPart>
                    <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>点検メモ</Typography>
                    <Field
                      id="tkMemo"
                      name="tkMemo"
                      component={renderTextField}
                      className='fields'
                      fullWidth
                      label="メモ"
                      type="text"
                      multiline={true}
                      rows={3}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      validate={[
                      ]}
                      InputProps={{
                        readOnly: isDisabled,
                      }}
                      // disabled={isDisabled}
                    />
                  </PaperPart>
                </Grid>
              </Grid>
              <Grid key="keyTkInfoFooter" item xs={12}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="flex-start"
                  spacing={1}
                >
                  {!isFuyouShow &&
                  <Grid key="keyTkInfoSave" item>
                    <PositiveButton
                      id="tkInfoSave"
                      variant="contained"
                      disabled={false}
                      startIcon={<SaveIcon />}
                      size="middle"
                      onClick={handleSubmit(this.doSave)}
                    >
                      <span>確定</span>
                    </PositiveButton>
                  </Grid>
                  }
                  {isFuyouShow &&
                  <Grid key="keyTkInfoSaveNo" item>
                    <PositiveButton
                      id="tkInfoSaveNo"
                      variant="contained"
                      disabled={false}
                      startIcon={<SaveIcon />}
                      size="middle"
                      onClick={handleSubmit(this.doSave)}
                    >
                      <span>改修不要登録</span>
                    </PositiveButton>
                  </Grid>
                  }
                  <Grid key="keyTkInfoBack" item>
                    <NegativeButton
                      id="tkInfoBack"
                      variant="contained"
                      startIcon={<KeyboardReturnIcon />}
                      size="middle"
                      onClick={handleSubmit(this.doBack)}
                    >
                      <span>閉じる</span>
                    </NegativeButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </PaperPart>
        </form>
      </Modal>
    );
  }
};

TkInfo.propTypes={
  // classes: PropTypes.object,
  values: PropTypes.object,
  // getMessage: PropTypes.func,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  doShowMessage: PropTypes.func,
  change: PropTypes.func,
  doSetInitValues: PropTypes.func,
  initialValues: PropTypes.object,
  dirty: PropTypes.bool,
  // 呼び出し元設定
  supplyPointNo: PropTypes.string.isRequired,
  tkStatus: PropTypes.string.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  closeButton: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'TkInfo';

TkInfo = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(TkInfo));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(withFormatMessage(withMediaQuery()(TkInfo)))),
);
